<template>
    <div>
        <!-- Label with Required Indicator -->
        <label :for="field.id" class="block text-sm font-medium text-gray-700 mb-2">
            {{ field.label }} <span v-if="field.required" class="text-red-500">*</span>
        </label>

        <!-- Input Field -->
        <input v-model="localValue" :id="field.id" :required="field.required" type="text"
            class="block w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />

        <!-- Field Description -->
        <p v-if="field.description" class="text-xs text-gray-500 mt-1">
            {{ field.description }}
        </p>

        <!-- Error Message (optional) -->

    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: String,
    },
    data() {
        return {
            localValue: this.modelValue || this.field.value || '',
        };
    },
    watch: {
        localValue(newValue) {
            this.$emit('update:modelValue', newValue);
        },
    },
};
</script>